import MarkdownPage from "../components/MarkdownPage";

export default function TermsAndConditions() {
  return (
    <MarkdownPage
      title="Terms & Conditions"
      file="/legal/terms-and-conditions.md"
    />
  );
}
